// removed by extract-text-webpack-plugin
module.exports = {"content":"app-content--fNsQq"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/app.scss
// module id = 2ShL
// module chunks = 4